import React from 'react';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const StatsSection = () => {
  const stats = [
    {
      id: 'horario-laboral',
      number: '58%',
      title: 'Contactos fuera horario laboral',
      subtitle: 'Los prospectos prefieren contactar cuando las oficinas están cerradas.',
      icon: AccessTimeIcon,
      color: '#4f81bd',
    },
    {
      id: 'contactabilidad',
      number: '99%',
      title: 'Tasa de contactabilidad estable',
      subtitle: 'Atención consistente 24/7 todos los días del año.',
      icon: TrendingUpIcon,
      color: '#4f81bd',
    },
    {
      id: 'casos-uso',
      number: '10+',
      title: 'Casos de uso diferentes',
      subtitle: 'Los agentes IA de Zeller cubren múltiples escenarios comerciales.',
      icon: SmartToyIcon,
      color: '#4f81bd',
    },
  ];

  return (
    <Box
      sx={{
        py: 8,
        backgroundColor: '#ffffff',
      }}
    >
      <Container maxWidth="lg">
        {/* Título de la sección */}
        <Typography
          variant="h2"
          align="center"
          sx={{
            mb: 6,
            fontWeight: 'bold',
            color: '#2c3e50',
            fontSize: { xs: '2rem', md: '3rem' },
          }}
        >
          Resultados Comprobados
        </Typography>

        {/* Estadísticas */}
        <Grid container spacing={4} sx={{ mb: 6 }}>
          {stats.map((stat) => {
            const IconComponent = stat.icon;
            return (
              <Grid item xs={12} md={4} key={stat.id}>
                <Card
                  sx={{
                    height: '100%',
                    boxShadow: 2,
                    borderRadius: 2,
                    transition: 'transform 0.3s ease-in-out',
                    // '&:hover': {
                    //   transform: 'translateY(-5px)',
                    //   boxShadow: 4,
                    // },
                  }}
                >
                  <CardContent
                    sx={{
                      p: 4,
                      textAlign: 'center',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minHeight: '280px',
                    }}
                  >
                    {/* Icon */}
                    <IconComponent
                      sx={{
                        fontSize: '2.5rem',
                        color: stat.color,
                        mb: 2,
                      }}
                    />

                    {/* Number */}
                    <Typography
                      variant="h1"
                      sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '3rem', md: '4rem' },
                        color: stat.color,
                        mb: 2,
                        lineHeight: 1,
                      }}
                    >
                      {stat.number}
                    </Typography>

                    {/* Title */}
                    <Typography
                      variant="h6"
                      sx={{
                        color: '#2c3e50',
                        fontWeight: 'bold',
                        mb: 2,
                        fontSize: { xs: '1.1rem', md: '1.25rem' },
                      }}
                    >
                      {stat.title}
                    </Typography>

                    {/* Subtitle */}
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#546e7a',
                        lineHeight: 1.6,
                        fontSize: '0.95rem',
                        textAlign: 'center',
                      }}
                    >
                      {stat.subtitle}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

export default StatsSection;
